if (process.env.NODE_ENV === 'production') {
  module.exports = require('./production');
} else {
  module.exports = require('./development');
}



//////////////////
// WEBPACK FOOTER
// ../~/@shopify/app-bridge/index.js
// module id = 934
// module chunks = 0